import { memo } from 'react';
import { SSO_URL_REDIRECT_KEY_MODIFY_CUSTOMER } from 'shared-modules/constants';
import SSOMyPage from '../SSOMyPage';

const MyPageCustomer = () => <SSOMyPage redirectUrlKey={SSO_URL_REDIRECT_KEY_MODIFY_CUSTOMER} />;

export default memo(MyPageCustomer);
